<template>
  <div class="realtimeplot-container">
    <!-- 连接状态提示区域 -->
    <div v-if="isReconnecting" class="connection-status">
      <el-alert
        :title="reconnectMessage"
        type="warning"
        :closable="false"
        show-icon
      >
      </el-alert>
    </div>

    <!-- 图表区域 -->
    <div class="chart-container">
      <div ref="chartRef"  style="width: 100%; height: 100%"></div>
    </div>

    <!-- 筛选条件和数据表格区域 -->
    <div class="control-panel">
      <!-- 筛选条件区域 -->
      <div class="filter-section">
        <el-form :inline="true" class="filter-row">
          <!-- 新增：变量选择框 -->
          <el-form-item class="filter-item variable-item" v-if="false">
            <el-select
              v-model="selectedVarNames"
              multiple
              collapse-tags
              collapse-tags-tooltip
              :placeholder="$t('message.historyRecord.selectVariables')"
              class="variable-select"
            >
              <el-option
                v-for="variable in allVariables"
                :key="variable.name"
                :label="variable.display_name"
                :value="variable.name"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('message.reaTimePlot.MonitoringDuration')">
            <el-input-number v-model="monitoringDuration" :min="6" />
            <el-button type="primary" @click="rollCallClick">
              {{ $t("message.reaTimePlot.rollCall") }}
            </el-button>
            <el-button type="primary" 
            :icon="Refresh" 
            :loading="partDataIsRollCallLoading"
            :disabled="!isConnected"
            @click="handleTrack">
              {{ $t("message.reaTimePlot.track") }}
            </el-button>
                 <!-- 在追踪按钮旁边添加专门的停止按钮 -->
            <el-button 
              v-if="isTracking"
              type="danger" 
              @click="handleStopTrack"              
              class="stop-btn"
            >
              {{ t("message.ClientProjectMonitorSystemMonitorParmater.stopTrack") }}
            </el-button>
          </el-form-item>

        </el-form>
      </div>

        <!-- 指定间隔和指定时间追踪 -->
             <!-- 指定间隔和指定时间追踪 -->
       <el-dialog
          v-model="TrackDialogVisible"
          :title="$t('message.ClientProjectMonitorSystemMonitorParmater.track')"
          width="500px"
        >
          <div class="edit-dialog-content">
            <el-form :model="trackForm" label-width="140px">
              <!-- 更新方式选择 -->
              <el-form-item :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateMode')">
                <el-radio-group v-model="trackForm.updateMode">
                  <el-radio value="auto">
                    {{ $t('message.ClientProjectMonitorSystemMonitorParmater.autoUpdate') }}
                  </el-radio>
                  <el-radio value="manual">
                    {{ $t('message.ClientProjectMonitorSystemMonitorParmater.manualUpdate') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 手动更新间隔选项 -->
              <el-form-item 
                v-if="trackForm.updateMode === 'manual'" 
                :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateInterval')"
              >
              <el-radio-group v-model="trackForm.manualInterval">
                <el-radio :label="1">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.oneSecond') }}</el-radio>
                <el-radio :label="5">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.fiveSeconds') }}</el-radio>
                <el-radio :label="10">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.tenSeconds') }}</el-radio>
                <el-radio :label="30">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.thirtySeconds') }}</el-radio>
                <el-radio :label="0">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.noUpdate') }}</el-radio>
                <el-radio :label="-1">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.customInterval') }}</el-radio>
              </el-radio-group>
              
              <!-- 自定义间隔输入框 -->
              <div v-if="trackForm.manualInterval === -1" class="custom-interval-input">
                <el-input-number 
                  v-model="trackForm.customIntervalValue" 
                  :min="1" 
                  :max="3600"
                  :step="1"
                  style="width: 120px; margin-top: 8px;"
                  :placeholder="$t('message.ClientProjectMonitorSystemMonitorParmater.enterInterval')"
                />
                <span class="interval-unit">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.seconds') }}</span>
              </div>
            </el-form-item>

            <!-- 自动更新说明 -->
            <el-form-item 
              v-if="trackForm.updateMode === 'auto'" 
              :label="$t('message.ClientProjectMonitorSystemMonitorParmater.updateInfo')"
            >
              <div class="auto-update-info">
                <el-icon><InfoFilled /></el-icon>
                <span>{{ $t('message.ClientProjectMonitorSystemMonitorParmater.autoUpdateDesc') }}</span>
              </div>
            </el-form-item>

            <!-- 追踪持续时间 -->
            <el-form-item :label="$t('message.reaTimePlot.duration')">
              <div class="duration-input">
                <el-input-number 
                  v-model="trackForm.durationValue" 
                  :min="1" 
                  :max="480"
                  style="width: 120px;"
                />
                <span class="duration-unit">{{ $t('message.ClientProjectMonitorSystemMonitorParmater.minutes') }}</span>
              </div>
              <div class="duration-tips">
                {{ $t('message.ClientProjectMonitorSystemMonitorParmater.durationTips') }}
              </div>
            </el-form-item>

            <!-- 追踪状态显示 -->
            <el-form-item v-if="isTracking" :label="$t('message.ClientProjectMonitorSystemMonitorParmater.trackingStatus')">
              <div class="tracking-status">
                <el-tag type="success" size="small">
                  <el-icon class="is-loading"><Loading /></el-icon>
                  {{ $t('message.ClientProjectMonitorSystemMonitorParmater.trackingActive') }}
                </el-tag>
                <div class="remaining-time">
                  {{ $t('message.ClientProjectMonitorSystemMonitorParmater.remainingTime') }}: 
                  {{ formatRemainingTime() }}
                </div>
                <div class="current-interval" v-if="trackForm.updateMode === 'manual' && getCurrentInterval() > 0">
                  {{ $t('message.ClientProjectMonitorSystemMonitorParmater.currentInterval') }}: {{ getCurrentInterval() }} {{ $t('message.ClientProjectMonitorSystemMonitorParmater.seconds') }}
                </div>
              </div>
            </el-form-item>
          </el-form>

          <div class="dialog-footer">
            <!-- 停止追踪按钮 -->
            <el-button 
              v-if="isTracking" 
              type="danger" 
              @click="stopTracking"
              class="stop-btn"
            >
              <el-icon><SwitchButton /></el-icon>
              {{ $t("message.ClientProjectMonitorSystemMonitorParmater.stopTrack") }}
            </el-button>      
            
            <el-button 
              type="primary" 
              @click="confirmTrack"
              :disabled="isTracking || !isFormValid"
              :loading="partDataIsRollCallLoading"
            >
              {{ isTracking ? $t("message.ClientProjectMonitorSystemMonitorParmater.tracking") : $t("message.common.confirm") }}
            </el-button>
            <el-button @click="TrackDialogVisible = false">
              {{ $t("message.common.cancel") }}
            </el-button>
          </div>
        </div>
      </el-dialog>

   
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  onUnmounted,
  watch,
  computed
} from "vue";

import * as echarts from "echarts";
import { ElMessage } from "element-plus";
import { heart } from "@/api/UserManager";
import { useI18n } from "vue-i18n";
//import baseConfig from "@/public/config.json";
import { useSignalR } from "@/utils/signalR";
import { getToken } from "@/utils/auth";
import { rollCall } from "@/api/DeviceManagement";
import { defineProps } from 'vue'

import { formatValue,formatValueRemove0 } from "@/api/DeviceManagement";
const { t } = useI18n();

// 接收传入的变量
const props = defineProps({
  varDevices: {
    type: Object,
    required: true,
    default: () => ({})
  },
  projectName: {
    type: String,
    default: ''
  },
  deviceId: {
    type: [String, Number],
    default: null
  }
});

// 所有变量（从 props.varDevices 转换而来）
const allVariables = computed(() => {
  const variables = [];
  for (const [deviceCode, varObjects] of Object.entries(props.varDevices)) {
    varObjects.forEach(varObj => {
      variables.push({
        name: varObj.name,
        display_name: varObj.title,
        deviceCode: deviceCode,
        mult: varObj.mult,
       var_decimal: varObj.var_decimal,
        companyId: varObj.companyId
      });
    });
  }
  return variables;
});


// 创建一个变量名到对象的映射
const variableMap = computed(() => {
  const map = new Map();
  allVariables.value.forEach(variable => {
    map.set(variable.name, variable);
  });
  return map;
});

/**
 * 获取变量的乘法系数和小数位数（优化版）
 * @param {string} varName 变量名（必填）
 * @returns {Object} { mult: number, var_decimal: number } 带默认值的系数和小数位
 */
const getMultAndDecimal = (varName) => {
  // 1. 入参校验：避免空值/非字符串入参导致Map查询失败
  if (!varName || typeof varName !== 'string') {
    console.warn('getMultAndDecimal: 变量名必须为非空字符串', varName);
    return { mult: 1, var_decimal: 0 };
  }

  // 2. Map查询（O(1)效率，替代原数组find的O(n)）
  const variable = variableMap.value.get(varName);

  // 3. 数值校验：确保返回的是合法数字（防非数字/空字符串等异常值）
  const mult = Number(variable?.mult);
  const var_decimal = Number(variable?.var_decimal);

  // 4. 兜底默认值：仅当转换后为NaN/Infinity时使用默认值
  return {
    mult: isFinite(mult) ? mult : 1,
    var_decimal: isFinite(var_decimal) ? var_decimal : 0
  };
};


// 选中的变量名数组 - 只作为查询条件
const selectedVarNames = ref([]);

// 当前显示的表格列变量 - 只在查询后更新
const currentDisplayVariables = ref([]);

// 根据选中的变量重新构建 varDevices - 用于查询
const filteredVarDevices = computed(() => {
  const result = {};
  
  if (selectedVarNames.value.length === 0) {
    // 如果没有选择任何变量，返回所有变量
    return props.varDevices;
  }
  
  for (const [deviceCode, varObjects] of Object.entries(props.varDevices)) {
    const filteredVars = varObjects.filter(varObj => 
      selectedVarNames.value.includes(varObj.name)
    );
    
    if (filteredVars.length > 0) {
      result[deviceCode] = filteredVars;
    }
  }
  
  return result;
});



// 获取变量名数组（用于内部处理）
const getVariableNames = () => {
  if (selectedVarNames.value.length === 0) {
    return allVariables.value.map(v => v.name);
  }
  return selectedVarNames.value;
};

// 获取显示名数组（用于显示）
// const getDisplayNames = () => {
//   return currentDisplayVariables.value.map(v => v.display_name);
// };

// 图表相关
// 存储Y轴范围数据
const yAxisRanges = ref({});
// 存储图例选择状态
const legendSelectedState = ref({});

const chartRef = ref(null);
let chartInstance = null;
 
// 缓存数据 - 用于存储所有接收到的实时数据
const cachedData = ref([]);

// 分页配置
const pagination = reactive({
  currentPage: 1,
  pageSize: 10,
  total: 0,
});

// 定时器相关
let timer = null;
const refreshInterval = 30 * 1000; // 30秒刷新一次数据
let heartTimer = null;
let trackTimer = null;
const refreshHeartInterval = 10 * 60 * 1000; // 十分钟刷新一次数据

// 监控时长
const monitoringDuration = ref(1);
const MAX_CACHE_HOURS = ref(0);

 

// SignalR 相关
//const url = `${baseConfig.apiBaseUrl}/subscriptionHub`;
const url = ref('');

const {
  isConnected,
  isReconnecting,
  reconnectAttempts,
  reconnectDelay,
  start,
  stop,
  invoke,
  on,
  off,
  onConnected,
} = useSignalR(url, {
  accessTokenFactory: () => getToken() || "",
  automaticReconnect: true,
});


// 追踪相关
// 添加剩余时间定时器变量
const trackingStartTime = ref(null); // 新增：追踪开始时间
let remainingTimeTimer = null;
const isTracking = ref(false); // 新增：追踪状态
const TrackDialogVisible = ref(false);
const partDataIsRollCallLoading = ref(false); // 点名刷新加载状态
const remainingTime = ref(0); // 新增：剩余时间
const trackForm = ref({
  updateMode: 'manual', // 'auto' 或 'manual'
  manualInterval: 5, // 手动更新间隔：1, 5, 10, 30, 0, -1(自定义)
  customIntervalValue: 60, // 自定义间隔值（秒）
  durationValue: 10, // 持续时间（分钟）
});
import { getConfig } from '@/utils/configTool';
// 3. 异步加载配置函数
async function loadConfig() {
  try {
      // 获取完整配置对象
    const config = await getConfig();
    // 解构使用
    // 4. 赋值 SignalR url
    url.value = config.signalRUrl;
    //console.log('SignalR 地址配置成功：', signalRUrl.value);
  } catch (error) {
    console.error('加载配置文件失败：', error); 
  }
}

// 表单验证
const isFormValid = computed(() => {
  if (trackForm.value.updateMode === 'manual') {
    if (trackForm.value.manualInterval === -1) {
      // 自定义间隔模式，需要验证自定义值
      return trackForm.value.customIntervalValue > 0 && trackForm.value.customIntervalValue <= 3600;
    }
  }
  return true;
});

 // 获取当前间隔时间
const getCurrentInterval = () => {
  if (trackForm.value.updateMode === 'auto') {
    return 0; // 自动模式返回0
  }
  
  if (trackForm.value.updateMode === 'manual') {
    if (trackForm.value.manualInterval === -1) {
      return trackForm.value.customIntervalValue; // 自定义间隔
    }
    return trackForm.value.manualInterval; // 预设间隔
  }
  return 0;
};
// 格式化剩余时间显示
const formatRemainingTime = () => {
  if (!isTracking.value || remainingTime.value <= 0) return '00:00';
  
  const minutes = Math.floor(remainingTime.value / 60);
  const seconds = remainingTime.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

// 更新剩余时间
const updateRemainingTime = () => {
  if (isTracking.value && trackingStartTime.value) {
    const elapsed = Math.floor((Date.now() - trackingStartTime.value) / 1000);
    const totalDuration = trackForm.value.durationValue * 60;
    remainingTime.value = Math.max(0, totalDuration - elapsed);
    
    if (remainingTime.value <= 0) {
      stopTracking();
    }
  }
};

const reconnectMessage = computed(() => {
  return t("message.reaTimePlot.reconnecting", {
    attempts: reconnectAttempts.value,
    seconds: Math.round(reconnectDelay.value / 1000),
  });
});


// 更新显示的表格列
const updateDisplayVariables = () => {
  if (selectedVarNames.value.length === 0) {
    // 如果没有选择任何变量，显示所有变量
    currentDisplayVariables.value = allVariables.value;
  } else {
    // 显示选中的变量
    currentDisplayVariables.value = allVariables.value.filter(variable => 
      selectedVarNames.value.includes(variable.name)
    );
  }
};
 
// 初始化图表
const initChart = () => {
  if (!chartRef.value) return;
  
  try {
    chartInstance = echarts.init(chartRef.value);
    
    const option = {
      title: {
        text: t("message.reaTimePlot.deviceVariableMonitor"),
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: [],
      },
      grid: {
        left: "3%",
        right: "40px",
        bottom: "15%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: [],
      },
      yAxis: {
        type: "value",
      },
      series: [],
      dataZoom: [
        { 
          type: "inside", 
          xAxisIndex: [0],
          start: 0, 
          end: 100 
        },
        { 
          type: "slider",
          xAxisIndex: [0],
          start: 0, 
          end: 100,
          bottom: 10,
          height: 20,
          show: true
        },
        { 
          type: "inside", 
          yAxisIndex: [0],
          start: 0, 
          end: 100,
          zoomLock: false
        },
        { 
          type: "slider",
          yAxisIndex: [0],
          start: 0, 
          end: 100,
          right: 20,
          width: 12,
          show: true,
          zoomLock: false,
          brushSelect: false
        }
      ]
    };

    chartInstance.setOption(option);
  } catch (error) {
    console.error('Chart initialization failed:', error);
  }
};

// 格式化日期
const formatDate = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  return new Intl.DateTimeFormat("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
    .format(date)
    .replace(/\//g, "-")
    .replace(/(\d+):(\d+):(\d+)/, "$1:$2:$3");
};



// 处理接收到的设备数据
const processDeviceData = (jsonStr) => {
  try {
    const receivedData = JSON.parse(jsonStr);
    const receivedTime = new Date(receivedData.time);
    const formattedTime = formatDate(receivedTime);

    // 查找是否已存在相同时间戳的数据行
    const existingDataIndex = cachedData.value.findIndex(
      item => item.timestamp === formattedTime && item.DeviceCode === receivedData.DeviceCode
    );

    let newDataItem;

    if (existingDataIndex !== -1) {
      // 如果已存在相同时间戳的数据，则更新该行数据
      newDataItem = cachedData.value[existingDataIndex];
    } else {
      // 否则创建新的数据行
      newDataItem = {
        timestamp: formattedTime,
        rawTime: receivedTime,
        DeviceCode: receivedData.DeviceCode,
        imei: receivedData.imei,
        Type: receivedData.Type,
        Priority: receivedData.Priority,
      };
    }

    // 处理变量数据
    if (receivedData.Vars && Array.isArray(receivedData.Vars)) {
      receivedData.Vars.forEach((variable) => {
        if (variable && variable.Name && variable.Error == 0) {
          const { mult, var_decimal } = getMultAndDecimal(variable.Name);        
          console.error(`processDeviceData --variable.Value:${variable.Value};mult:${mult}--var_decimal: ${var_decimal}`);
          newDataItem[variable.Name] = formatValue(variable.Value,mult, var_decimal);          
          newDataItem[`${variable.Name}_Error`] = variable.Error ?? 0;
        }
      });
    }

    if (existingDataIndex === -1) {
      // 如果是新数据行，添加到缓存
      cachedData.value.push(newDataItem);
    } else {
      // 如果是更新现有数据行，替换原数据
      cachedData.value[existingDataIndex] = newDataItem;
    }

    pagination.total = cachedData.value.length;

    // 清理过期数据
    const now = new Date();
    MAX_CACHE_HOURS.value = monitoringDuration.value * 60 * 60 * 1000;
    const cacheTimeAgo = new Date(now.getTime() - MAX_CACHE_HOURS.value);
    cachedData.value = cachedData.value.filter(
      (item) => item.rawTime > cacheTimeAgo
    );

    // 按时间降序排序
    cachedData.value.sort((a, b) => b.rawTime - a.rawTime);

    return cachedData.value;
  } catch (error) {
    console.error("数据处理错误:", error);
    ElMessage.error(t("message.reaTimePlot.dataProcessError"));
    return [];
  }
};

const hexToRgb = (hex) => {
  // 移除 # 号
  hex = hex.replace(/^#/, '');
  
  // 处理3位和6位颜色值
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  
  // 解析RGB值
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  return `${r}, ${g}, ${b}`;
};
// 根据索引获取颜色 - 扩展颜色数组
const getColorByIndex = (index) => {
  const colors = [
    '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de',
    '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#ff9f7f',
    '#1e90ff', '#32cd32', '#ff4500', '#6a5acd', '#ff69b4',
    '#00ced1', '#ffa500', '#8a2be2', '#5f9ea0', '#d2691e',
    '#6495ed', '#dc143c', '#00ff7f', '#ff1493', '#00bfff',
    '#696969', '#ff8c00', '#7cfc00', '#da70d6', '#cd5c5c',
    '#4682b4', '#9acd32', '#ff6347', '#8470ff', '#ff6eb4',
    '#00eeee', '#ff7f50', '#9370db', '#66cdaa', '#f08080'
  ];
  return colors[index % colors.length];
};


// 计算Y轴数据范围
const calculateYAxisRange = (data, variableName) => {
  const values = data
    .map(item => parseFloat(item[variableName]))
    .filter(value => !isNaN(value));
  
  if (values.length === 0) {
    return { min: 0, max: 1 };
  }
  
  const min = Math.min(...values);
  const max = Math.max(...values);
  
  // 添加10%的padding
  const range = max - min;
  const padding = range * 0.1 || 0.1;
  return {
    min: min - padding,
    max: max + padding
  };
};


// 创建动态多Y轴配置 - 不做数量限制
const createDynamicYAxisConfig = (variables, processedData) => {
  const yAxisConfig = [];
  
  // 移除数量限制，为每个变量创建Y轴
  for (let i = 0; i < variables.length; i++) {
    const variable = variables[i];
    
    // 计算Y轴位置和偏移量
    const isLeft = i % 2 === 0;
    const axisIndex = Math.floor(i / 2);
    const offset = axisIndex * 60;
    
    // 计算该变量的数据范围
    const range = calculateYAxisRange(processedData, variable.name);
    yAxisRanges.value[variable.name] = range;
    
    // 将变量名称转换为竖排：每个字符后面加换行符
    const verticalName = variable.display_name.split('').join('\n');
    
    yAxisConfig.push({
      type: 'value',
      name: verticalName,
      position: isLeft ? 'left' : 'right',
      offset: offset,
      axisLine: {
        show: true,
        lineStyle: {
          color: getColorByIndex(i),
          width: 1.5
        },
        onZero: false // 禁止自动对齐
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: getColorByIndex(i)
        }
      },
      axisLabel: {
        formatter: function(value) {
          // 确保6位数字都能显示：-0.2000 这种格式
          if (Math.abs(value) < 0.001 && value !== 0) {
            return value.toExponential(3); // 科学计数法显示极小值
          } else if (Math.abs(value) < 1) {
            return value.toFixed(4); // 显示4位小数
          } else if (Math.abs(value) < 10) {
            return value.toFixed(3); // 显示3位小数
          } else if (Math.abs(value) < 100) {
            return value.toFixed(2); // 显示2位小数
          } else if (Math.abs(value) < 1000) {
            return value.toFixed(1); // 显示1位小数
          } else if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + 'M';
          } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + 'k';
          }
          return Number(value.toFixed(0)).toString();
        },
        color: getColorByIndex(i),
        fontSize: 11,
        show: true, // 始终显示标签
        margin: isLeft ? 15 : 8, // 左侧增加边距
        padding: [0, isLeft ? -10 : 0, 0, isLeft ? 0 : 0], // 调整内边距        padding: [0, isLeft ? -10 : 0, 0, isLeft ? 0 : 0], // 调整内边距
        align: isLeft ? 'right' : 'left', // 左侧右对齐，右侧左对齐
        verticalAlign: 'middle' // 垂直居中对齐
      },
      nameTextStyle: {
        color: getColorByIndex(i),
        fontSize: 10,
        fontWeight: 'bold',
        align: 'center',
        lineHeight: 16,
        verticalAlign: 'top',
        // 根据左右位置调整内边距
        padding: isLeft ? [50, 0, 0, 15] : [0, 15, 0, 0] // 左侧增加左边距
      },
      nameLocation: 'end',
      nameGap: isLeft ? 35 : -30, // 增加左侧间距，减少右侧间距
      splitLine: {
        show: false // 隐藏分割线，避免重叠
      },
      // 使用固定范围
      min: range.min,
      max: range.max,
      scale: false, // 禁用自动缩放
      boundaryGap: ['10%', '10%'],
      z: 100 + i // 固定Z层级
    });
  }
  
  return yAxisConfig;
};
const updateChart = (data) => {
  if (!chartInstance || !currentDisplayVariables.value.length) return;

  try {
    // 性能警告
    if (currentDisplayVariables.value.length > 20) {
      console.warn('变量数量较多，可能会影响图表性能');
    }

    // 按时间戳升序排序
    const sortedData = [...data].sort(
      (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
    );

    // 数据聚合函数 - 当数据量超过1000时进行聚合
    const aggregateData = (data, maxPoints = 3000) => {
      if (data.length <= maxPoints) {
        return data;
      }

      console.log(`数据量 ${data.length} 超过 ${maxPoints}，进行聚合处理`);
      
      const aggregatedData = [];
      const interval = Math.ceil(data.length / maxPoints);
      
      for (let i = 0; i < data.length; i += interval) {
        const chunk = data.slice(i, i + interval);
        if (chunk.length === 0) continue;
        
        // 取中间点的时间戳
        const middleIndex = Math.floor(chunk.length / 2);
        const aggregatedItem = {
          ...chunk[middleIndex], // 使用中间点的数据作为基础
          timestamp: chunk[middleIndex].timestamp
        };
        
        // 对每个变量进行聚合计算
        currentDisplayVariables.value.forEach(variable => {
          const values = chunk
            .map(item => parseFloat(item[variable.name]))
            .filter(value => !isNaN(value));
          
          if (values.length > 0) {
            // 计算平均值
            const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
            aggregatedItem[variable.name] = Number(avg.toFixed(4));
          } else {
            aggregatedItem[variable.name] = null;
          }
        });
        
        aggregatedData.push(aggregatedItem);
      }
      
      console.log(`聚合后数据量: ${aggregatedData.length}`);
      return aggregatedData;
    };

    // 应用数据聚合
    const processedData = aggregateData(sortedData, 3000);

    // 移除数量限制，显示所有选中的变量
    const displayVars = currentDisplayVariables.value;
    const yAxisConfig = createDynamicYAxisConfig(displayVars, processedData);

    const timeData = processedData.map((item) => item.timestamp);
    
    // 初始化图例选择状态 - 只更新当前显示的变量
    const initialLegendSelected = {};
    displayVars.forEach(variable => {
      initialLegendSelected[variable.display_name] = 
        legendSelectedState.value[variable.display_name] !== undefined 
          ? legendSelectedState.value[variable.display_name] 
          : true;
    });
    
    // 只更新当前变量的图例状态，保留其他变量的状态
    const updatedLegendState = { ...legendSelectedState.value };
    displayVars.forEach(variable => {
      if (updatedLegendState[variable.display_name] === undefined) {
        updatedLegendState[variable.display_name] = true;
      }
    });
    legendSelectedState.value = updatedLegendState;

    const seriesData = displayVars.map((variable, index) => {
      const isSelected = legendSelectedState.value[variable.display_name] !== false;
      
      return {
        name: variable.display_name,
        type: "line",
        yAxisIndex: index, // 每个系列对应一个Y轴
        symbol: isSelected ? "circle" : "none",
        symbolSize: isSelected ? 3 : 0,
        smooth: true,
        lineStyle: {
          width: 1.2,
          opacity: isSelected ? 1 : 0.2
        },
        itemStyle: {
          borderWidth: 1,
          borderColor: "#fff",
          opacity: isSelected ? 1 : 0.2
        },
        data: processedData.map((item) => {
          const value = parseFloat(item[variable.name]);
          return isNaN(value) ? null : value;
        }),
        emphasis: {
          disabled: false, // 确保悬停效果可用
          lineStyle: {
            width: 2,
            opacity: 1
          }
        }
      };
    });

    // 动态生成Y轴滑动条配置
    const yAxisDataZoom = [];
    const yAxisSliderDataZoom = [];
    
    // 调整滚动条间距以适应更多Y轴
    const yAxisToSliderDistance = 20;
    const sliderSpacing = 14; // 减小间距以适应更多滚动条
    
    // 为每个Y轴生成滑动条配置
    displayVars.forEach((_, index) => {
      // 内部滑动条
      yAxisDataZoom.push({
        type: "inside", 
        yAxisIndex: index,
        start: 0, 
        end: 100,
        zoomLock: false
      });
      
      // 外部滑动条
      const sliderRight = yAxisToSliderDistance + index * sliderSpacing;
      
      // 获取对应Y轴的颜色
      const yAxisColor = getColorByIndex(index);

      yAxisSliderDataZoom.push({
        type: "slider",
        yAxisIndex: index,
        start: 0, 
        end: 100,
        right: sliderRight,
        width: 10, // 减小宽度以适应更多滚动条
        show: true,
        zoomLock: false,
        brushSelect: false,
        fillerColor: `rgba(${hexToRgb(yAxisColor)}, 0.2)`,
        borderColor: yAxisColor,
        handleSize: 6, // 减小手柄大小
        handleStyle: {
          color: yAxisColor
        },
        backgroundColor: 'rgba(240, 242, 245, 0.8)',
        textStyle: {
          color: '#606266',
          fontSize: 15 // 减小字体大小
        },
        dataBackground: {
          lineStyle: {
            color: yAxisColor,
            opacity: 0.3
          },
          areaStyle: {
            color: yAxisColor
          }
        }
      });
    });

    // 动态计算右边距
    const totalSlidersWidth = displayVars.length * 10 + (displayVars.length - 1) * 6;
    const gridRight = yAxisToSliderDistance + totalSlidersWidth + 60;
    
    // 动态计算左边距 - 根据左侧Y轴数量调整，调整为3个英文字符宽度（约24px）
    const leftYAxisCount = displayVars.filter((_, i) => i % 2 === 0).length;
    const gridLeft = leftYAxisCount === 0 ? '3%' : `${Math.max(24, leftYAxisCount * 15)}px`; // 最小24px，每个左侧Y轴增加15px

    // 动态调整图例位置和样式
    const legendTop = displayVars.length > 8 ? '40px' : '0px';
    const gridTop = displayVars.length > 8 ? '80px' : '50px';

    // 计算时间间隔，用于智能显示标签
    const calculateLabelInterval = () => {
      const dataLength = timeData.length;
      if (dataLength <= 10) return 1;
      if (dataLength <= 20) return 2;
      if (dataLength <= 50) return 5;
      if (dataLength <= 100) return 10;
      return Math.ceil(dataLength / 15);
    };

    const labelInterval = calculateLabelInterval();

    const option = {
      legend: {
        data: displayVars.map(v => v.display_name),
        selected: initialLegendSelected,
        top: legendTop,
        type: 'scroll',
        pageButtonItemGap: 3,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageTextStyle: {
          fontSize: 15
        },
        textStyle: {
          fontSize: 15
        },
        itemHeight: 10,
        itemWidth: 20,
        itemGap: 3,
        selector: false,
        inactiveColor: '#ccc'
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: timeData,
        axisLabel: {
          rotate: 0,
          formatter: (value, index) => {
            if (index % labelInterval === 0) {
              const date = new Date(value);
              const hours = date.getHours().toString().padStart(2, '0');
              const minutes = date.getMinutes().toString().padStart(2, '0');
              return `${hours}:${minutes}`;
            }
            return '';
          },
          fontSize: 15,
          margin: 8,
          interval: (index) => index % labelInterval === 0,
        },
        axisLine: {
          lineStyle: {
            color: '#dcdfe6'
          }
        },
        axisTick: {
          lineStyle: {
            color: '#dcdfe6'
          },
          interval: (index) => index % labelInterval === 0,
        }
      },
      yAxis: yAxisConfig,
      series: seriesData,
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985",
            formatter: (params) => {
              if (params.axisDimension === 'x') {
                const date = new Date(params.value);
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                const seconds = date.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
              }
              
              if (params.axisDimension === 'y') {
                if (typeof params.value === 'number') {
                  return parseFloat(params.value.toFixed(2)).toString();
                }
                return params.value;
              }
              return params.value;
            }
          },
        },
        confine: true,
        extraCssText: 'max-width: 300px; word-break: break-all;',
        textStyle: {
          fontSize: 15
        },
        formatter: (params) => {
          let result = '';
          if (params.length > 0) {
            const date = new Date(params[0].axisValue);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            const seconds = date.getSeconds().toString().padStart(2, '0');
            
            const isAggregated = data.length > 3000;
            if (isAggregated) {
               result += `<div style="margin-bottom: 4px; color: #909399; font-size: 12px;">📊 数据已聚合 (${data.length} → ${processedData.length} 个点)</div>`;
            }
            
            result += `<div style="margin-bottom: 8px; font-weight: bold;">${year}-${month}-${day} ${hours}:${minutes}:${seconds}</div>`;
          }
          
          params.forEach((item) => {
            const value = item.value !== null && item.value !== undefined 
              ? typeof item.value === 'number' 
                ? formatValueRemove0(item.value)
                : item.value
              : '--';
            result += `
              <div style="display: flex; align-items: center; margin: 4px 0;">
                <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: ${item.color}; margin-right: 8px;"></span>
                <span style="flex: 1;">${item.seriesName}:</span>
                <span style="font-weight: bold; margin-left: 8px;">${value}</span>
              </div>
            `;
          });
          return result;
        }
      },
      grid: {
        left: gridLeft, // 使用动态左边距（像素单位）
        right: `${gridRight}px`,
        bottom: "4%",  // 从12%改为4%，减小X轴与滚动条之间的间隔
        top: gridTop,
        containLabel: true,
      },
      dataZoom: [
        { 
          type: "inside", 
          xAxisIndex: [0],
          start: 0, 
          end: 100 
        },
        { 
          type: "slider",
          xAxisIndex: [0],
          start: 0, 
          end: 100,
          bottom: 5,  // 从5改为1，将滚动条向上移动，减小间隔
          height: 14,  // 稍微减小高度
          show: true,
          handleSize: 8,
          handleStyle: {
            color: '#5470c6'
          },
          backgroundColor: 'rgba(240, 242, 245, 0.8)',
          borderColor: '#dcdfe6',
          fillerColor: 'rgba(84, 112, 198, 0.3)',
          dataBackground: {
            lineStyle: {
              color: '#909399',
              opacity: 0.3
            },
            areaStyle: {
              color: '#909399',
              opacity: 0.1
            }
          },
          selectedDataBackground: {
            lineStyle: {
              color: '#5470c6',
              opacity: 0.6
            },
            areaStyle: {
              color: '#5470c6',
              opacity: 0.2
            }
          }
        },
        ...yAxisDataZoom,
        ...yAxisSliderDataZoom
      ],
      animation: false,
      animationDuration: 0
    };

    // 移除旧的图例选择事件监听器
    chartInstance.off('legendselectchanged');
    
    // 设置图表选项
    chartInstance.setOption(option, { notMerge: true });
    
    // 修复图例选择事件监听器 - 确保只影响被点击的图例
    chartInstance.on('legendselectchanged', function(params) {
      const selected = params.selected;
      const changedSeries = params.name;
      
      // 更新全局状态
      if (selected[changedSeries] !== undefined) {
        legendSelectedState.value[changedSeries] = selected[changedSeries];
      }
      
      // 获取当前的系列数据
      const currentOption = chartInstance.getOption();
      const series = currentOption.series;
      
      // 找到对应的系列索引
      const seriesIndex = series.findIndex(s => s.name === changedSeries);
      
      if (seriesIndex !== -1) {
        const isSelected = selected[changedSeries];
        
        // 创建一个新的系列数组，只修改被点击的系列
        const updatedSeries = series.map((seriesItem, index) => {
          if (index === seriesIndex) {
            return {
              ...seriesItem,
              lineStyle: {
                ...seriesItem.lineStyle,
                opacity: isSelected ? 1 : 0.2
              },
              itemStyle: {
                ...seriesItem.itemStyle,
                opacity: isSelected ? 1 : 0.2
              },
              symbol: isSelected ? 'circle' : 'none',
              symbolSize: isSelected ? 3 : 0
            };
          }
          return seriesItem;
        });
        
        // 只更新对应的系列，保持其他系列不变
        chartInstance.setOption({
          series: updatedSeries
        }, {
          notMerge: false,
          replaceMerge: 'series',
          lazyUpdate: false
        });
      }
    });
    
    // 延迟调整尺寸
    setTimeout(() => {
      chartInstance.resize({
        animation: {
          duration: 0
        }
      });
    }, 100);
    
  } catch (error) {
    console.error('Chart update failed:', error);
  }
};
// const updateChart = (data) => {
//   if (!chartInstance || !currentDisplayVariables.value.length) return;

//   try {
//     // 性能警告
//     if (currentDisplayVariables.value.length > 20) {
//       console.warn('变量数量较多，可能会影响图表性能');
//     }

//     // 按时间戳升序排序
//     const sortedData = [...data].sort(
//       (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
//     );

//     // 数据聚合函数 - 当数据量超过1000时进行聚合
//     const aggregateData = (data, maxPoints = 1000) => {
//       if (data.length <= maxPoints) {
//         return data;
//       }

//       console.log(`数据量 ${data.length} 超过 ${maxPoints}，进行聚合处理`);
      
//       const aggregatedData = [];
//       const interval = Math.ceil(data.length / maxPoints);
      
//       for (let i = 0; i < data.length; i += interval) {
//         const chunk = data.slice(i, i + interval);
//         if (chunk.length === 0) continue;
        
//         // 取中间点的时间戳
//         const middleIndex = Math.floor(chunk.length / 2);
//         const aggregatedItem = {
//           ...chunk[middleIndex], // 使用中间点的数据作为基础
//           timestamp: chunk[middleIndex].timestamp
//         };
        
//         // 对每个变量进行聚合计算
//         currentDisplayVariables.value.forEach(variable => {
//           const values = chunk
//             .map(item => parseFloat(item[variable.name]))
//             .filter(value => !isNaN(value));
          
//           if (values.length > 0) {
//             // 计算平均值
//             const avg = values.reduce((sum, val) => sum + val, 0) / values.length;
//             aggregatedItem[variable.name] = Number(avg.toFixed(4));
//           } else {
//             aggregatedItem[variable.name] = null;
//           }
//         });
        
//         aggregatedData.push(aggregatedItem);
//       }
      
//       console.log(`聚合后数据量: ${aggregatedData.length}`);
//       return aggregatedData;
//     };

//     // 应用数据聚合
//     const processedData = aggregateData(sortedData, 1000);

//     // 移除数量限制，显示所有选中的变量
//     const displayVars = currentDisplayVariables.value;
//     const yAxisConfig = createDynamicYAxisConfig(displayVars, processedData);

//     const timeData = processedData.map((item) => item.timestamp);
    
//     // 初始化图例选择状态 - 只更新当前显示的变量
//     const initialLegendSelected = {};
//     displayVars.forEach(variable => {
//       initialLegendSelected[variable.display_name] = 
//         legendSelectedState.value[variable.display_name] !== undefined 
//           ? legendSelectedState.value[variable.display_name] 
//           : true;
//     });
    
//     // 只更新当前变量的图例状态，保留其他变量的状态
//     const updatedLegendState = { ...legendSelectedState.value };
//     displayVars.forEach(variable => {
//       if (updatedLegendState[variable.display_name] === undefined) {
//         updatedLegendState[variable.display_name] = true;
//       }
//     });
//     legendSelectedState.value = updatedLegendState;

//     const seriesData = displayVars.map((variable, index) => {
//       const isSelected = legendSelectedState.value[variable.display_name] !== false;
      
//       return {
//         name: variable.display_name,
//         type: "line",
//         yAxisIndex: index, // 每个系列对应一个Y轴
//         symbol: isSelected ? "circle" : "none",
//         symbolSize: isSelected ? 3 : 0,
//         smooth: true,
//         lineStyle: {
//           width: 1.2,
//           opacity: isSelected ? 1 : 0.2
//         },
//         itemStyle: {
//           borderWidth: 1,
//           borderColor: "#fff",
//           opacity: isSelected ? 1 : 0.2
//         },
//         data: processedData.map((item) => {
//           const value = parseFloat(item[variable.name]);
//           return isNaN(value) ? null : value;
//         }),
//         emphasis: {
//           disabled: false, // 确保悬停效果可用
//           lineStyle: {
//             width: 2,
//             opacity: 1
//           }
//         }
//       };
//     });

//     // 动态生成Y轴滑动条配置
//     const yAxisDataZoom = [];
//     const yAxisSliderDataZoom = [];
    
//     // 调整滚动条间距以适应更多Y轴
//     const yAxisToSliderDistance = 20;
//     const sliderSpacing = 14; // 减小间距以适应更多滚动条
    
//     // 为每个Y轴生成滑动条配置
//     displayVars.forEach((_, index) => {
//       // 内部滑动条
//       yAxisDataZoom.push({
//         type: "inside", 
//         yAxisIndex: index,
//         start: 0, 
//         end: 100,
//         zoomLock: false
//       });
      
//       // 外部滑动条
//       const sliderRight = yAxisToSliderDistance + index * sliderSpacing;
      
//       // 获取对应Y轴的颜色
//       const yAxisColor = getColorByIndex(index);

//       yAxisSliderDataZoom.push({
//         type: "slider",
//         yAxisIndex: index,
//         start: 0, 
//         end: 100,
//         right: sliderRight,
//         width: 10, // 减小宽度以适应更多滚动条
//         show: true,
//         zoomLock: false,
//         brushSelect: false,
//         fillerColor: `rgba(${hexToRgb(yAxisColor)}, 0.2)`,
//         borderColor: yAxisColor,
//         handleSize: 6, // 减小手柄大小
//         handleStyle: {
//           color: yAxisColor
//         },
//         backgroundColor: 'rgba(240, 242, 245, 0.8)',
//         textStyle: {
//           color: '#606266',
//           fontSize: 15 // 减小字体大小
//         },
//         dataBackground: {
//           lineStyle: {
//             color: yAxisColor,
//             opacity: 0.3
//           },
//           areaStyle: {
//             color: yAxisColor
//           }
//         }
//       });
//     });

//     // 动态计算右边距
//     const totalSlidersWidth = displayVars.length * 10 + (displayVars.length - 1) * 6;
//     const gridRight = yAxisToSliderDistance + totalSlidersWidth + 60;
    
//     // 动态计算左边距 - 根据左侧Y轴数量调整，调整为3个英文字符宽度（约24px）
//     const leftYAxisCount = displayVars.filter((_, i) => i % 2 === 0).length;
//     const gridLeft = leftYAxisCount === 0 ? '3%' : `${Math.max(24, leftYAxisCount * 15)}px`; // 最小24px，每个左侧Y轴增加15px

//     // 动态调整图例位置和样式
//     const legendTop = displayVars.length > 8 ? '40px' : '0px';
//     const gridTop = displayVars.length > 8 ? '80px' : '50px';

//     // 计算时间间隔，用于智能显示标签
//     const calculateLabelInterval = () => {
//       const dataLength = timeData.length;
//       if (dataLength <= 10) return 1;
//       if (dataLength <= 20) return 2;
//       if (dataLength <= 50) return 5;
//       if (dataLength <= 100) return 10;
//       return Math.ceil(dataLength / 15);
//     };

//     const labelInterval = calculateLabelInterval();

//     const option = {
//       legend: {
//         data: displayVars.map(v => v.display_name),
//         selected: initialLegendSelected,
//         top: legendTop,
//         type: 'scroll',
//         pageButtonItemGap: 3,
//         pageButtonPosition: 'end',
//         pageFormatter: '{current}/{total}',
//         pageTextStyle: {
//           fontSize: 15
//         },
//         textStyle: {
//           fontSize: 15
//         },
//         itemHeight: 10,
//         itemWidth: 20,
//         itemGap: 3,
//         selector: false,
//         inactiveColor: '#ccc'
//       },
//       xAxis: {
//         type: "category",
//         boundaryGap: false,
//         data: timeData,
//         axisLabel: {
//           rotate: 0,
//           formatter: (value, index) => {
//             if (index % labelInterval === 0) {
//               const date = new Date(value);
//               const hours = date.getHours().toString().padStart(2, '0');
//               const minutes = date.getMinutes().toString().padStart(2, '0');
//               return `${hours}:${minutes}`;
//             }
//             return '';
//           },
//           fontSize: 15,
//           margin: 8,
//           interval: (index) => index % labelInterval === 0,
//         },
//         axisLine: {
//           lineStyle: {
//             color: '#dcdfe6'
//           }
//         },
//         axisTick: {
//           lineStyle: {
//             color: '#dcdfe6'
//           },
//           interval: (index) => index % labelInterval === 0,
//         }
//       },
//       yAxis: yAxisConfig,
//       series: seriesData,
//       tooltip: {
//         trigger: "axis",
//         axisPointer: {
//           type: "cross",
//           label: {
//             backgroundColor: "#6a7985",
//             formatter: (params) => {
//               if (params.axisDimension === 'x') {
//                 const date = new Date(params.value);
//                 const year = date.getFullYear();
//                 const month = (date.getMonth() + 1).toString().padStart(2, '0');
//                 const day = date.getDate().toString().padStart(2, '0');
//                 const hours = date.getHours().toString().padStart(2, '0');
//                 const minutes = date.getMinutes().toString().padStart(2, '0');
//                 const seconds = date.getSeconds().toString().padStart(2, '0');
//                 return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//               }
//               return params.value;
//             }
//           },
//         },
//         confine: true,
//         extraCssText: 'max-width: 300px; word-break: break-all;',
//         textStyle: {
//           fontSize: 15
//         },
//         formatter: (params) => {
//           let result = '';
//           if (params.length > 0) {
//             const date = new Date(params[0].axisValue);
//             const year = date.getFullYear();
//             const month = (date.getMonth() + 1).toString().padStart(2, '0');
//             const day = date.getDate().toString().padStart(2, '0');
//             const hours = date.getHours().toString().padStart(2, '0');
//             const minutes = date.getMinutes().toString().padStart(2, '0');
//             const seconds = date.getSeconds().toString().padStart(2, '0');
            
//             const isAggregated = data.length > 1000;
//             if (isAggregated) {
//               result += `<div style="margin-bottom: 4px; color: #909399; font-size: 12px;">📊 数据已聚合 (${data.length} → ${processedData.length} 个点)</div>`;
//             }
            
//             result += `<div style="margin-bottom: 8px; font-weight: bold;">${year}-${month}-${day} ${hours}:${minutes}:${seconds}</div>`;
//           }
          
//           params.forEach((item) => {
//             const value = item.value !== null && item.value !== undefined 
//               ? typeof item.value === 'number' 
//                 ? item.value.toFixed(4) 
//                 : item.value
//               : '--';
//             result += `
//               <div style="display: flex; align-items: center; margin: 4px 0;">
//                 <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: ${item.color}; margin-right: 8px;"></span>
//                 <span style="flex: 1;">${item.seriesName}:</span>
//                 <span style="font-weight: bold; margin-left: 8px;">${value}</span>
//               </div>
//             `;
//           });
//           return result;
//         }
//       },
//       grid: {
//         left: gridLeft, // 使用动态左边距（像素单位）
//         right: `${gridRight}px`,
//         bottom: "12%",
//         top: gridTop,
//         containLabel: true,
//       },
//       dataZoom: [
//         { 
//           type: "inside", 
//           xAxisIndex: [0],
//           start: 0, 
//           end: 100 
//         },
//         { 
//           type: "slider",
//           xAxisIndex: [0],
//           start: 0, 
//           end: 100,
//           bottom: 5,
//           height: 16,
//           show: true,
//           handleSize: 8,
//           handleStyle: {
//             color: '#5470c6'
//           },
//           backgroundColor: 'rgba(240, 242, 245, 0.8)',
//           borderColor: '#dcdfe6',
//           fillerColor: 'rgba(84, 112, 198, 0.3)',
//           dataBackground: {
//             lineStyle: {
//               color: '#909399',
//               opacity: 0.3
//             },
//             areaStyle: {
//               color: '#909399',
//               opacity: 0.1
//             }
//           },
//           selectedDataBackground: {
//             lineStyle: {
//               color: '#5470c6',
//               opacity: 0.6
//             },
//             areaStyle: {
//               color: '#5470c6',
//               opacity: 0.2
//             }
//           }
//         },
//         ...yAxisDataZoom,
//         ...yAxisSliderDataZoom
//       ],
//       animation: false,
//       animationDuration: 0
//     };

//     // 移除旧的图例选择事件监听器
//     chartInstance.off('legendselectchanged');
    
//     // 设置图表选项
//     chartInstance.setOption(option, { notMerge: true });
    
//     // 修复图例选择事件监听器 - 确保只影响被点击的图例
//     chartInstance.on('legendselectchanged', function(params) {
//       const selected = params.selected;
//       const changedSeries = params.name;
      
//       // 更新全局状态
//       if (selected[changedSeries] !== undefined) {
//         legendSelectedState.value[changedSeries] = selected[changedSeries];
//       }
      
//       // 获取当前的系列数据
//       const currentOption = chartInstance.getOption();
//       const series = currentOption.series;
      
//       // 找到对应的系列索引
//       const seriesIndex = series.findIndex(s => s.name === changedSeries);
      
//       if (seriesIndex !== -1) {
//         const isSelected = selected[changedSeries];
        
//         // 创建一个新的系列数组，只修改被点击的系列
//         const updatedSeries = series.map((seriesItem, index) => {
//           if (index === seriesIndex) {
//             return {
//               ...seriesItem,
//               lineStyle: {
//                 ...seriesItem.lineStyle,
//                 opacity: isSelected ? 1 : 0.2
//               },
//               itemStyle: {
//                 ...seriesItem.itemStyle,
//                 opacity: isSelected ? 1 : 0.2
//               },
//               symbol: isSelected ? 'circle' : 'none',
//               symbolSize: isSelected ? 3 : 0
//             };
//           }
//           return seriesItem;
//         });
        
//         // 只更新对应的系列，保持其他系列不变
//         chartInstance.setOption({
//           series: updatedSeries
//         }, {
//           notMerge: false,
//           replaceMerge: 'series',
//           lazyUpdate: false
//         });
//       }
//     });
    
//     // 延迟调整尺寸
//     setTimeout(() => {
//       chartInstance.resize({
//         animation: {
//           duration: 0
//         }
//       });
//     }, 100);
    
//   } catch (error) {
//     console.error('Chart update failed:', error);
//   }
// };
 

// 更新图表

// const updateChart = (data) => {
//   if (!chartInstance || !currentDisplayVariables.value.length) return;

//   // 按时间戳升序排序
//   const sortedData = [...data].sort(
//     (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
//   );

//   // 准备图表数据
//   const timeData = sortedData.map((item) => item.timestamp);
//   const seriesData = currentDisplayVariables.value.map((variable) => ({
//     name: variable.display_name,
//     type: "line",
//     symbol: "circle",
//     symbolSize: 6,
//     smooth: true,
//     lineStyle: {
//       width: 2,
//     },
//     itemStyle: {
//       borderWidth: 1,
//       borderColor: "#fff",
//     },
//     data: sortedData.map((item) => {
//       const value = parseFloat(item[variable.name]);
//       return isNaN(value) ? null : value;
//     }),
//   }));

//   // 图表配置
//   const option = {
//     legend: {
//       data: getDisplayNames(),
//       selected: Object.fromEntries(
//         currentDisplayVariables.value.map((variable) => [variable.display_name, true])
//       ),
//     },
//     xAxis: {
//       type: "category",
//       boundaryGap: false,
//       data: timeData,
//       axisLabel: {
//         rotate: 30,
//         formatter: (value, index) =>
//           index % Math.ceil(timeData.length / 10) === 0 ? value : "",
//       },
//     },
//     yAxis: {
//       type: "value",
//       scale: true,
//       axisLine: {
//         show: true,
//       },
//       splitLine: {
//         show: true,
//         lineStyle: {
//           type: "dashed",
//         },
//       },
//     },
//     series: seriesData,
//     dataZoom: [
//       { type: "inside", start: 0, end: 100 },
//       { start: 0, end: 100 },
//     ],
//     tooltip: {
//       trigger: "axis",
//       axisPointer: {
//         type: "cross",
//         label: {
//           backgroundColor: "#6a7985",
//         },
//       },
//     },
//     grid: {
//       left: "3%",
//       right: "4%",
//       bottom: "3%",
//       containLabel: true,
//     },
//   };

//   // 应用配置
//   chartInstance.setOption(option, { notMerge: true });
//   setTimeout(() => chartInstance.resize(), 100);
// };

 


// 开始自动刷新
const startAutoRefresh = () => {
  stopAutoRefresh();

  // 首次订阅
  if (selectedVarNames.value.length > 0) {
    sendMessage();
  }

  timer = setInterval(() => {
    if (selectedVarNames.value.length > 0) {
      sendMessage();
    }
  }, refreshInterval);

  // 启动心跳
  heartTimer = setInterval(() => {
    heart();
  }, refreshHeartInterval);
};

// 停止自动刷新
const stopAutoRefresh = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }

  if (heartTimer) {
    clearInterval(heartTimer);
    heartTimer = null;
  }
};

// 停止订阅
const stopSubscription = async () => {
  if (!isConnected.value) return;
  
  try {
    const token = getToken();
    if (!token) return;

    // 获取第一个设备的 deviceCode（假设只有一个设备）
    const deviceCodes = Object.keys(filteredVarDevices.value);
    if (deviceCodes.length === 0) return;

    const deviceCode = deviceCodes[0];

    const params = {
      token: token,
      deviceCode: deviceCode,
      imei: undefined,
      Dir: "d",
      type: 1,
      priority: 1,
      timer: new Date().toISOString(),
      r_data: [],
    };

    const jsonString = JSON.stringify(params);
    await invoke("ReleaseData", jsonString);
    console.log("订阅已停止");
  } catch (error) {
    console.error("停止订阅失败:", error);
  }
};

// 发送订阅消息
const sendMessage = async () => {
  if (!isConnected.value || selectedVarNames.value.length === 0) return;

  try {
    const token = getToken();
    if (!token) return;

    // 获取第一个设备的 deviceCode（假设只有一个设备）
    const deviceCodes = Object.keys(filteredVarDevices.value);
    if (deviceCodes.length === 0) return;

    const deviceCode = deviceCodes[0];

    const params = {
      token: token,
      deviceCode: deviceCode,
      imei: undefined,
      Dir: "d",
      type: 1,
      timer: new Date().toISOString(),
      priority: 1,
      r_data: getVariableNames().map(name => ({ name })),
    };

    const jsonString = JSON.stringify(params);
    await invoke("RequestData", jsonString);
  } catch (err) {
    console.error("Failed to send message:", err);
  }
};

// 消息处理
const handleNotification = async (message) => {
  try {
       if (isTracking.value ==true && trackForm.value.updateMode === 'manual' && trackForm.value.manualInterval === 0)    
        {
          console.log('停止实时数据更新');
          return;
        }

    const processedData = processDeviceData(message);
    updateChart(processedData); 
  } catch (error) {
    console.error("处理数据错误:", error);
    ElMessage.error(t("message.reaTimePlot.dataProcessError"));
  }
};
 
const rollCallClick = async () => {
  if (selectedVarNames.value.length === 0) {
    ElMessage.error(t("message.reaTimePlot.selectVariable"));
    return;
  }

  if (!isConnected.value) {
    ElMessage.error(t("message.reaTimePlot.connectError"));
    return;
  }

  try {
    const token = getToken();
    if (!token) return;

    // 按设备分组变量
    const deviceVariableGroups = groupVariablesByDevice();
    if (Object.keys(deviceVariableGroups).length === 0) {
      ElMessage.warning(t("message.reaTimePlot.noValidVariables"));
      return;
    }

    // 为每个设备创建点名请求
    const rollCallPromises = [];
    
    for (const [deviceCode, variableNames] of Object.entries(deviceVariableGroups)) {
      if (variableNames.length === 0) continue;
      
      // 将变量名按每5个分组
      const variableChunks = chunkArray(variableNames, 5);
      
      // 为每个变量包创建请求
      for (let i = 0; i < variableChunks.length; i++) {
        const chunk = variableChunks[i];
        
        const requestData = {
          token: token,
          deviceCode: deviceCode,
          imei: undefined,
          type: 4,
          dir: "Down",
          timer: new Date().toISOString(),
          priority: 1,
          r_data: chunk.map(name => ({ name })),
          w_data: [],
        };

        rollCallPromises.push(
          rollCall([requestData])
            .then(() => {
              console.log(`设备 ${deviceCode} 第${i + 1}/${variableChunks.length}包点名成功，变量数量: ${chunk.length}`);
            })
            .catch(error => {
              console.error(`设备 ${deviceCode} 第${i + 1}包点名失败:`, error);
              throw error;
            })
        );
        
        // 可选：添加延迟避免请求过于密集
        if (i < variableChunks.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 100));
        }
      }
    }

    // 并行发送所有点名请求
    await Promise.all(rollCallPromises);
    
    // ElMessage.success(
    //   t("message.reaTimePlot.rollCallSuccess", {
    //     deviceCount: Object.keys(deviceVariableGroups).length,
    //     variableCount: selectedVarNames.value.length
    //   })
    // );
    
  } catch (error) {
    console.error('点名操作失败:', error);
    ElMessage.error(
      error.response?.data?.message || 
      error.message || 
      t("message.reaTimePlot.dataProcessError")
    );
  }
};

// 辅助函数：按设备分组变量
const groupVariablesByDevice = () => {
  const deviceGroups = {};
  
  // 遍历所有选中的变量
  selectedVarNames.value.forEach(varName => {
    // 查找变量对应的设备
    let foundDevice = null;
    
    for (const [deviceCode, variables] of Object.entries(filteredVarDevices.value)) {
      if (variables.some(v => v.name === varName)) {
        foundDevice = deviceCode;
        break;
      }
    }
    
    if (foundDevice) {
      if (!deviceGroups[foundDevice]) {
        deviceGroups[foundDevice] = [];
      }
      deviceGroups[foundDevice].push(varName);
    }
  });
  
  return deviceGroups;
};

// 辅助函数：将数组按指定大小分块
const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

//停止追踪
const handleStopTrack = () => {
  
  // 清除定时器  
  stopTracking();
  //ElMessage.success(t("message.reaTimePlot.trackingStopped"));

};



const stopTracking = () => {
  
  if (trackTimer) {
    clearInterval(trackTimer);
    trackTimer = null;
  }
  
  if (remainingTimeTimer) {
    clearInterval(remainingTimeTimer);
    remainingTimeTimer = null;
  }
  partDataIsRollCallLoading.value = false;
  isTracking.value = false;
  trackingStartTime.value = null;
  remainingTime.value = 0;
  
  //ElMessage.success(t("message.ClientProjectMonitorSystemMonitorParmater.trackingStopped"));
};


// 追踪功能
const handleTrack = () => {
 
  if (selectedVarNames.value.length === 0) {
    ElMessage.error(t("message.reaTimePlot.selectVariable"));
    return;
  }
  TrackDialogVisible.value = true;
};

const confirmTrack = async () => {
  if (trackTimer) {
    clearInterval(trackTimer);
    trackTimer = null;
  }

  try {
    if (!isConnected.value) {
      ElMessage.error(t("message.ClientProjectMonitorSystemMonitorParmater.connectError"));
      return;
    }
    
    // 表单验证
    if (!isFormValid.value) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.invalidInterval"));
      return;
    }
    
    // 获取当前页面的所有变量
    const currentVariables = getVariableNames();
    if (currentVariables.length === 0) {
      ElMessage.warning(t("message.ClientProjectMonitorSystemMonitorParmater.noVariables"));
      return;
    }

   

    // 设置追踪状态
    partDataIsRollCallLoading.value = true;
    isTracking.value = true;
    trackingStartTime.value = Date.now();
    remainingTime.value = trackForm.value.durationValue * 60;

    // 启动剩余时间更新定时器
    remainingTimeTimer = setInterval(updateRemainingTime, 1000);

    // 立即执行一次数据获取
    await rollCallClick();
    
    // 根据更新模式设置定时器
    if (trackForm.value.updateMode === 'manual') {
      const interval = getCurrentInterval();
      if (interval > 0) {
        // 手动模式且有更新间隔
        trackTimer = setInterval(async () => {
          try {
            await rollCallClick();        
          } catch (error) {
            console.error("定时数据获取失败:", error);
            stopTracking();        
            ElMessage.error(t("message.reaTimePlot.dataProcessError"));
          }
        }, interval * 1000);
      }
      // 如果 interval = 0，则不设置定时器（不更新）
    } else if (trackForm.value.updateMode === 'auto') {
      // 自动模式 - 基于设备上传频率，这里可以设置一个较短的检查间隔
      trackTimer = setInterval(async () => {
        try {
          // 自动模式下可以更频繁地检查数据更新
          await startRealTimeSubscription();
        } catch (error) {
          console.error("自动更新检查失败:", error);
        }
      }, 2000); // 2秒检查一次
    }

    // 设置自动停止时间
    const durationMs = trackForm.value.durationValue * 60 * 1000;
    setTimeout(() => {
      if (isTracking.value) {
        stopTracking();        
        ElMessage.success(t("message.reaTimePlot.trackingCompleted"));
      }
    }, durationMs);

    TrackDialogVisible.value = false;
    ElMessage.success(t("message.ClientProjectMonitorSystemMonitorParmater.trackingStarted"));
  } catch (error) {
    console.error("启动实时跟踪失败:", error);
    stopTracking();
  } finally {
    partDataIsRollCallLoading.value = false;
  }
};



const startRealTimeSubscription = async () => {
  if (!isConnected.value) {
    console.log('SignalR 未连接，等待连接...');
    return;
  }
   
  try {
    await sendMessage();
    
  } catch (error) {
    console.error('启动实时订阅失败:', error);
  }
}


// 释放订阅
const RealeaseSubscribe = async () => {
  if (!isConnected.value) return true;

  try {
    await stopSubscription();
    return true;
  } catch (err) {
    console.error("释放订阅失败:", err);
    ElMessage.error(t("message.reaTimePlot.releaseFailed"));
    return false;
  }
};


// 监听变量选择变化
watch(
  () => selectedVarNames.value,
  (newVal) => {
    // 变量选择变化时，重新订阅数据
    if (newVal.length > 0) {
      sendMessage();
    } else {
      // 清空选择时停止订阅
      stopSubscription();
    }
  },
  { deep: true }
);

// 监听传入的变量设备数据变化
watch(
  () => props.varDevices,
  (newVarDevices) => {
    if (Object.keys(newVarDevices).length > 0) {
      // 初始化选中的变量（全选）
      selectedVarNames.value = allVariables.value.map(v => v.name);
      // 更新显示的表格列
      updateDisplayVariables();
    }
  },
  { immediate: true, deep: true }
);

// 生命周期
onMounted(async () => {
  await loadConfig();
  initChart();
  startAutoRefresh();
  await start();
  on("ReceiveMessage", handleNotification);
  await rollCallClick();
});

onBeforeUnmount(() => {
  if (chartInstance) {
    chartInstance.dispose();
  }
  stopAutoRefresh();
});

onUnmounted(async () => {
  if (selectedVarNames.value.length > 0) {
    try {
      await RealeaseSubscribe();
      if (trackTimer) {
        clearInterval(trackTimer);
        trackTimer = null;
      }      
    } catch (error) {
      console.error("组件卸载时释放订阅失败:", error);
    }
  }

  try {
    unsubscribe();
    off("ReceiveMessage", handleNotification);
    stop();
    stopTracking();
  } catch (error) {
    console.error("fail:", error);
  }
});

// 注册连接成功回调
const unsubscribe = onConnected(() => {
  if (selectedVarNames.value.length > 0) {
    sendMessage();
  }
  console.log("连接成功回调执行");
});
</script>
<style scoped>
.historyrecord-container {
  padding: 12px;
  background-color: #f5f7fa;
  display: flex;
  flex-direction: column;
  height: 100vh; /* 改为视口高度 */
  gap: 16px;
  box-sizing: border-box;
  overflow: hidden; /* 防止容器滚动 */
}

.chart-container {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex: 1; /* 图表区域占据剩余空间 */
  min-height: 0;
  height: calc(100vh - 200px); /* 动态计算高度 */
  position: relative;
}

.chart {
  width: 100%;
  height: 100%;
  min-height: 400px; /* 最小高度保证显示 */
}

.control-panel {
  background: #fff;
  padding: 16px 20px; /* 增加内边距 */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  height: auto;
  min-height: fit-content;
}

.filter-section {
  flex-shrink: 0;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px; /* 增加间距 */
  justify-content: space-between; /* 两端对齐 */
}

.filter-item {
  margin-bottom: 0;
  min-width: 200px;
  flex: 1;
  margin-right: 0;
}

.time-range-item {
  min-width: 500px; /* 增加宽度 */
  flex: 2; /* 时间范围占据更多空间 */
}

.time-range-group {
  display: flex;
  align-items: center;
  gap: 12px; /* 增加间距 */
  width: 100%;
}

.quick-time-select {
  width: 140px; /* 稍微增加宽度 */
  flex-shrink: 0;
}

.time-range-picker {
  flex: 1;
  min-width: 350px; /* 增加最小宽度 */
}

.action-buttons {
  display: flex;
  gap: 12px; /* 增加按钮间距 */
  align-items: center;
  flex-wrap: wrap;
  margin-left: auto; /* 靠右对齐 */
  flex-shrink: 0;
}

.action-btn {
  flex-shrink: 0;
  min-width: 100px; /* 设置按钮最小宽度 */
}

.data-section {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 16px;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.data-table {
  width: 100%;
  height: 100%;
}

.pagination-container {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  padding: 16px 0;
  border-top: 1px solid #ebeef5;
}

.pagination {
  width: 100%;
  justify-content: center;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .variable-item {
    min-width: 250px;
  }

  .filter-row {
    gap: 12px;
  }
  
  .filter-item {
    min-width: 180px;
    flex: 0 1 calc(33.333% - 12px);
  }
  
  .time-range-item {
    min-width: 450px;
  }
  
  .time-range-picker {
    min-width: 300px;
  }

  .action-buttons {
    margin-left: 0;
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 992px) {
  .variable-item {
    min-width: 200px;
  }
  .filter-item {
    flex: 0 1 calc(50% - 12px);
  }

  .time-range-item {
    min-width: 400px;
  }
  
  .time-range-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .quick-time-select,
  .time-range-picker {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .variable-item {
    min-width: 100%;
  }

  .historyrecord-container {
    padding: 8px;
    gap: 12px;
    height: auto; /* 小屏幕恢复自动高度 */
    min-height: 100vh;
  }
  
  .chart-container {
    padding: 8px;
    height: 400px; /* 固定高度 */
  }
  
  .control-panel {
    padding: 12px;
  }
  
  .filter-item {
    flex: 0 1 100%;
    min-width: auto;
  }
  
  .time-range-item {
    min-width: auto;
  }
  
  .time-range-group {
    flex-direction: column;
    gap: 8px;
  }
  
  .quick-time-select,
  .time-range-picker {
    width: 100%;
    min-width: auto;
  }
  
  .action-buttons {
    width: 100%;
    justify-content: space-between;
  }
  
  .action-btn {
    flex: 1;
    min-width: auto;
  }
  
  .filter-row {
    gap: 12px;
    flex-direction: column;
    align-items: stretch;
  }
}

.variable-item {
  min-width: 300px;
}

.variable-select {
  width: 100%;
}

@media (max-width: 480px) {
  .historyrecord-container {
    padding: 6px;
    gap: 10px;
  }
  
  .chart-container {
    padding: 6px;
    height: 350px;
  }
  
  .control-panel {
    padding: 10px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .action-btn {
    width: 100%;
  }
  
  .time-range-group {
    gap: 6px;
  }
}

/* 滚动条样式优化 - 参考文件中的样式 */
:deep(.el-table__body-wrapper)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

:deep(.el-table__body-wrapper)::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

:deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

:deep(.el-table__body-wrapper)::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 图表容器滚动条样式 */
.chart-container::-webkit-scrollbar {
  width: 6px;
}

.chart-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.chart-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.chart-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 控制面板滚动条 */
.control-panel::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.control-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.control-prollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.control-panel::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 主容器滚动条 */
.historyrecord-container::-webkit-scrollbar {
  width: 8px;
}

.historyrecord-container::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 4px;
}

.historyrecord-container::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 4px;
}

.historyrecord-container::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}

/* Firefox 滚动条样式 */
.historyrecord-container {
  scrollbar-width: thin;
  scrollbar-color: #dcdfe6 #f5f7fa;
}

.chart-container {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.control-panel {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 表格样式优化 */
:deep(.el-table) {
  font-size: 14px;
}

:deep(.el-table .el-table__cell) {
  padding: 8px 0;
}

:deep(.el-table .cell) {
  padding: 0 12px;
  line-height: 1.4;
}

/* 表单样式优化 */
:deep(.el-form-item__label) {
  font-weight: 500;
}

:deep(.el-cascader .el-input__inner) {
  height: 32px;
  line-height: 30px;
}

/* 加载状态优化 */
:deep(.el-loading-mask) {
  background-color: rgba(255, 255, 255, 0.8);
}

/* 复选框样式优化 */
:deep(.variable-checkbox .el-checkbox__label) {
  font-size: 14px;
  color: #606266;
}

/* ECharts 容器滚动条处理 */
:deep(.echarts-for-react) {
  height: 100% !important;
}

/* 确保图表响应式 */
.chart {
  position: relative;
}

/* 滚动条显示优化 */
@media (max-width: 768px) {
  .historyrecord-container::-webkit-scrollbar,
  .chart-container::-webkit-scrollbar,
  .control-panel::-webkit-scrollbar {
    width: 4px;
  }
}

/* 隐藏默认滚动条（仅在不滚动时） */
.chart-container {
  scrollbar-width: none; /* Firefox */
}

.chart-container::-webkit-scrollbar {
  display: none; /* Chrome/Safari */
}

/* 当内容溢出时显示滚动条 */
.chart-container:hover {
  scrollbar-width: thin; /* Firefox */
}

.chart-container:hover::-webkit-scrollbar {
  display: block; /* Chrome/Safari */
  width: 6px;
}

.chart-container:hover::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 3px;
}

/* 追踪对话框样式 */
.auto-update-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0f9ff;
  border-radius: 4px;
  border: 1px solid #e1f5fe;
  color: #0288d1;
  font-size: 14px;
}

.duration-input {
  display: flex;
  align-items: center;
  gap: 8px;
}

.duration-unit {
  color: #666;
  font-size: 14px;
}

.duration-tips {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}

.custom-interval-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.interval-unit {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
}

.tracking-status {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.remaining-time {
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
}

.current-interval {
  font-size: 13px;
  color: #52c41a;
  font-weight: 500;
}

.stop-btn {
  margin-right: auto;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .edit-dialog-content {
    padding: 10px;
  }
  
  :deep(.el-form-item__label) {
    width: 120px !important;
  }
  
  :deep(.el-form-item__content) {
    margin-left: 120px !important;
  }
  
  .custom-interval-input {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
</style>